import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { toast } from "react-toastify";
import "../../styles/pt/pt-trials.css";
import "../../styles/open-pages/open-pages.css";
import { fetchUserDetailsByMobileData } from "../../redux/reducers/apiSlice";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import {
  otpRequestAPIMobile,
  otpVerifyAPIMobile,
} from "../../data/ApiEndpoints";
import CommonLoginPage from "./CommonLoginPage";

const CommonOpenPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;
  const { userDetailsByMobile } = useSelector((state) => state.api);
  const timerIdRef = useRef(null);

  const [decryptedText, setDecryptedText] = useState(null);
  const iniUserInfo = {
    mobile: "",
    name: "",
    profile: "",
    email: "",
    gym_name: "",
    gym_id: "",
    user_id: "",
    account_type: "",
    ticket_account_type: "",
  };
  const [userInfo, setUserInfo] = useState(iniUserInfo);
  const [errors, setErrors] = useState({});
  const [showForm, setShowForm] = useState(false);
  const iniModValues = {
    isModOpen: false,
    otp: "",
    timerCount: "",
    requestNumber: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModValues = () => {
    setModValues(iniModValues);
  };

  const getUserDetailsByMobileData = () => {
    dispatch(
      fetchUserDetailsByMobileData({
        userMobile: userInfo.mobile,
        token: "",
        qps: "&is_token=1",
      })
    );
    setShowForm(true);
  };

  const onClickFetchDetails = () => {
    if (userInfo.mobile && userInfo.mobile?.length === 10) {
      const payload = {
        mobile: userInfo?.mobile,
        otp_type: "sms",
        sms: 1,
        is_staff: 1,
      };
      handleVertfyOTP(payload, otpRequestAPIMobile, "request-otp");
    } else {
      toast.error("Please Enter Mobile Number. (Number Must Be 10 Digit)");
      setErrors({
        userMobile: "Mobile Number Should Be 10 Digit",
      });
    }
  };

  const startTimer = () => {
    setModValues((prevs) => ({ ...prevs, timerCount: 60 }));

    if (timerIdRef.current) {
      clearInterval(timerIdRef.current);
    }

    timerIdRef.current = setInterval(() => {
      setModValues((prevs) => {
        if (prevs.timerCount > 0) {
          return { ...prevs, timerCount: prevs.timerCount - 1 };
        } else {
          clearInterval(timerIdRef.current);
          return prevs;
        }
      });
    }, 1000);
  };

  const handleVertfyOTP = async (payload, apiEndoint, callFor) => {
    const method = "POST";
    const endpoint = apiEndoint;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        if (callFor === "request-otp") {
          startTimer();
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            requestNumber: userInfo?.mobile,
            otp: "",
          }));
        } else if (callFor === "verify-otp") {
          getUserDetailsByMobileData();

          closeModValues();
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        setModValues((prevs) => ({
          ...prevs,
          otp: "",
        }));
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (userInfoData) {
      setDecryptedText(userInfoData);
      setUserInfo((prevs) => ({
        ...prevs,
        user_id: userInfoData?.uid,
        mobile: userInfoData?.mobile || prevs?.mobile,
        name: userInfoData?.name,
        email: userInfoData?.email,
        gym_id: userInfoData?.gym_id,
        gym_name: userInfoData?.gym_name,
        profile: userInfoData?.profile,
        account_type: userInfoData?.account_type,
        ticket_account_type: userInfoData?.ticket_account_type,
      }));
    }
  }, [userInfoData]);

  // console.log("userDetailsByMobile", userDetailsByMobile);

  useEffect(() => {
    if (
      showForm &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      setShowForm(false);

      const {
        uid,
        name,
        email,
        profile,
        gym_id,
        gym_name,
        account_type,
        ticket_account_type,
        token,
        mobile,
      } = userDetailsByMobile?.data?.[0];

      setUserInfo((prevs) => ({
        ...prevs,
        user_id: uid,
        mobile: mobile,
        name: name,
        email: email,
        gym_id: gym_id,
        gym_name: gym_name,
        profile: profile,
        account_type: account_type,
        ticket_account_type: ticket_account_type,
      }));
      setDecryptedText({
        user_id: uid,
        name: name,
        email: email,
        mobile: mobile,
        token: token,
        gym_id: gym_id,
        gym_name: gym_name,
        profile: profile,
        account_type: account_type,
        ticket_account_type: ticket_account_type,
      });
    } else if (showForm && userDetailsByMobile?.status === false) {
      toast.error(userDetailsByMobile?.message);
      setShowForm(false);
      setUserInfo(iniUserInfo);
      setDecryptedText("");
      return;
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (location.state?.shouldLogout) {
      setUserInfo(iniUserInfo);
      setDecryptedText(null);
      setModValues(iniModValues);
      setErrors({});
      localStorage.removeItem("pageState");

      navigate("/open-access", {
        state: { shouldLogout: false, userInfo: null, decryptedText: null },
        replace: true,
      });

      return;
    }

    if (decryptedText && !location.state?.shouldLogout) {
      const redirectTo = location?.state?.from || "/open-access/all-pages";

      navigate(redirectTo, {
        state: { userInfo, decryptedText },
      });
    }
  }, [decryptedText]);

  // useEffect(() => {
  //   const originalFetch = window.fetch;

  //   window.fetch = async (...args) => {
  //     try {
  //       const response = await originalFetch(...args);

  //       if (response.status === 401) {
  //         console.log("Unauthorized: Logging out");
  //         navigate("/open-access");
  //         localStorage.removeItem("pageState");
  //       }

  //       return response;
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //       throw error;
  //     }
  //   };

  //   return () => {
  //     window.fetch = originalFetch;
  //   };
  // }, []);

  // console.log("decryptedText=> ", decryptedText);

  return (
    <HelmetWrapper title="WTF: Common Open Page">
      <Container fluid className="bg-cloud-k p-0 gobal-container">
        <CommonLoginPage
          errors={errors}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          onClickFetchDetails={onClickFetchDetails}
          modValues={modValues}
          setModValues={setModValues}
          onClickResend={() => {
            const payload = {
              mobile: modValues.requestNumber,
              otp_type: "sms",
              sms: 1,
              is_staff: 1,
            };
            handleVertfyOTP(payload, otpRequestAPIMobile, "request-otp");
          }}
          onClickSubmit={() => {
            const payload = {
              mobile: modValues.requestNumber,
              otp: modValues.otp,
              n_token: "",
              device_id: "",
            };
            handleVertfyOTP(payload, otpVerifyAPIMobile, "verify-otp");
          }}
          onClickChangeNumber={() => {
            setModValues(iniModValues);
          }}
        />
      </Container>
    </HelmetWrapper>
  );
};

export default CommonOpenPage;
